// Cost savings recommendations for each budget category
// Each recommendation targets a budget item by id

export const defaultRecommendations = [
  {
    id: "sav-1",
    budgetId: 2,
    title: "Handle permit paperwork yourself",
    description: "Your architect's $10K quote includes permit submission. Verify no overlap with this line. Pre-application meeting is free. Design review fees are fixed by the city — savings come from avoiding a planning consultant.",
    currentCost: 16000,
    proposedCost: 12000,
    savings: 4000,
    risk: "low",
    effort: "medium",
  },
  {
    id: "sav-2",
    budgetId: 3,
    title: "Bundle geotech with architect",
    description: "Some architects have preferred geotech engineers with bundled rates. Your architect may already have a relationship. Arborist report can be as low as $800-$1,500 if few protected trees are near the work zone.",
    currentCost: 5000,
    proposedCost: 3000,
    savings: 2000,
    risk: "low",
    effort: "low",
  },
  {
    id: "sav-3",
    budgetId: 4,
    title: "Owner-assisted demo",
    description: "Non-structural demo (clearing interior finishes, site prep) can be done by the homeowner or day labor. The load-bearing wall removal still needs a licensed contractor. Could save $5K-$8K on labor.",
    currentCost: 21000,
    proposedCost: 14000,
    savings: 7000,
    risk: "medium",
    effort: "high",
  },
  {
    id: "sav-4",
    budgetId: 11,
    title: "DIY flooring installation",
    description: "Mohawk Coastal Couture is a click-lock floating floor — very DIY-friendly. Save ~$1,800 install labor. Allow 1-2 weekends for 460 sq ft.",
    currentCost: 4500,
    proposedCost: 2700,
    savings: 1800,
    risk: "low",
    effort: "medium",
  },
  {
    id: "sav-5",
    budgetId: 18,
    title: "Use laminate countertop",
    description: "Skip the $8K quartz upgrade — modern laminate looks good and is far more budget-friendly at $500-$1,000. Can always upgrade countertops later.",
    currentCost: 8000,
    proposedCost: 99,
    savings: 7901,
    risk: "low",
    effort: "low",
  },
  {
    id: "sav-7",
    budgetId: 20,
    title: "DIY backsplash tile",
    description: "Backsplash is one of the most popular DIY kitchen projects. Materials cost ~$500-$800 for peel-and-stick or subway tile. Save on $2K+ labor.",
    currentCost: 3000,
    proposedCost: 800,
    savings: 2200,
    risk: "low",
    effort: "medium",
  },
  {
    id: "sav-8",
    budgetId: 13,
    title: "DIY interior painting",
    description: "Standard ceiling height makes painting straightforward — no scaffolding. Materials cost ~$1,500-$2,000 for 824 sq ft. Save on $7K labor. Allow 1-2 weekends.",
    currentCost: 9000,
    proposedCost: 2000,
    savings: 7000,
    risk: "low",
    effort: "high",
  },
  {
    id: "sav-9",
    budgetId: 16,
    title: "Wait for Costco/holiday sales",
    description: "Your Café oven, fridge, and warming drawer are from Best Buy — prices drop $200-$700 on Memorial Day, Labor Day, and Black Friday. Best Buy also offers bundle discounts (buy 3+ Café appliances, save up to $700). Check open-box options too.",
    currentCost: 14199,
    proposedCost: 12500,
    savings: 1699,
    risk: "low",
    effort: "low",
  },
  {
    id: "sav-10",
    budgetId: 22,
    title: "Get competing roof quotes",
    description: "You have a $30,815 Good tier quote. Getting 2-3 more quotes may reveal a lower price. Better/Best tiers available at $33,923/$44,567 if you want to upgrade. Winter is off-season and cheaper.",
    currentCost: 30815,
    proposedCost: 28000,
    savings: 2815,
    risk: "low",
    effort: "medium",
  },
  {
    id: "sav-11",
    budgetId: 9,
    title: "Reuse existing HVAC system",
    description: "If your existing HVAC unit is under 10 years old and adequately sized, you may only need duct extension ($3K-$5K) rather than a system resize. Have an HVAC tech evaluate before committing.",
    currentCost: 14000,
    proposedCost: 5000,
    savings: 9000,
    risk: "medium",
    effort: "low",
  },
  {
    id: "sav-12",
    budgetId: 14,
    title: "Shop fixture sales & clearance",
    description: "Light fixtures from overstock/clearance retailers (Build.com, Wayfair, FB Marketplace) can save 40-60% vs retail.",
    currentCost: 5000,
    proposedCost: 2500,
    savings: 2500,
    risk: "low",
    effort: "medium",
  },
];
